import type { ListViewSchema } from "./types";

export const bookingListViewSchema: ListViewSchema = {
  doctype: "Booking",
  views: {
    experience: {
      columns: [
        { fieldname: "name", label: "Booking ID", width: 120, type: "Data" },
        { fieldname: "status", label: "Status", width: 110, type: "Status" },
        { fieldname: "booking_date", label: "Date", width: 110, type: "Date" },
        { fieldname: "start_time", label: "Start", width: 80, type: "Time" },
        { fieldname: "end_time", label: "End", width: 80, type: "Time", hideOnMobile: true },
        { fieldname: "item_name", label: "Item", width: "grow", type: "Data" },
        { fieldname: "customer_name", label: "Customer", width: 150, type: "Data" },
        { fieldname: "price", label: "Price", width: 100, type: "Currency", align: "right" },
      ],
      defaultSort: { fieldname: "booking_date", direction: "asc" },
      additionalFields: [
        "item_code",
        "customer_phone",
        "customer_email",
        "notes",
        "sales_order",
        "booking_number",
        "checked_in_at",
        "checked_out_at",
      ],
      quickFilters: [
        { id: "all", label: "All", filters: [], default: true },
        { id: "pending", label: "Pending", filters: [["status", "=", "Pending"]], pillVariant: "warning" },
        { id: "confirmed", label: "Confirmed", filters: [["status", "=", "Confirmed"]] },
        { id: "paid", label: "Paid", filters: [["status", "=", "Paid"]], pillVariant: "success" },
        { id: "completed", label: "Completed", filters: [["status", "=", "Completed"]] },
        { id: "cancelled", label: "Cancelled", filters: [["status", "=", "Cancelled"]], pillVariant: "danger" },
      ],
    },
    system: {
      columns: [],
    },
  },
};
